import { useFieldSet } from "@/components/utils/useFieldSet";
import { LinkButton } from "@/flokit/core/button/link-button";
import { showToast } from "@/flokit/core/toast/show-toast";
import { useRouter } from "next/router";
import { sendSigninMagicLink } from "../../../../../modules/api-docs";
import { URLS } from "../../../../../utils/urls";
import { ModalService } from "../../../../services/modal.service";
import {
  BaseVerifyEmailSignInModal,
  baseEmailSchema,
} from "./base-signin-modal";

const ApplicantSignInModal = () => {
  const emailFieldSet = useFieldSet({ email: "" }, [], baseEmailSchema);
  const router = useRouter();
  const org = router.query.org as string;
  const jobExtension = router.query.jobExtension as string;
  const agencyRedirectUrl = jobExtension
    ? URLS.agencySelfApplyJobApplication(org, jobExtension)
    : URLS.agencySelfApplyJobsList(org, true);

  return (
    <BaseVerifyEmailSignInModal
      emailFieldSet={emailFieldSet}
      org={org}
      title="Candidate Sign in"
      center
      subtitle={
        <LinkButton
          href={agencyRedirectUrl}
          onClick={() => {
            ModalService.closeModal();
          }}
          color="custom"
          UNSAFE_className="!px-0 !mx-0 !w-fit !inline-flex !font-semibold text-navy"
        >
          Are you an agency? Click here
        </LinkButton>
      }
      emailFieldLabel="Candidate Email"
      onEmailChange={emailFieldSet.curriedOnChange("email")}
      onSubmitSignInEmailRequest={async () => {
        if (!emailFieldSet.values.email) {
          showToast({
            message: "Please enter an email",
            type: "error",
          });
          return;
        }
        return sendSigninMagicLink({
          email: emailFieldSet.values.email,
          orgFriendlyName: org,
          redirectUrl: window.location.pathname,
          jobExtension: jobExtension ?? null,
        });
      }}
    />
  );
};
export const openApplicantSignInModal = () => {
  ModalService.openModal(
    () => {
      return <ApplicantSignInModal />;
    },
    {
      width: 520,
      mobileFriendly: true,
      preventAutoFocus: true,
    },
  );
};
